var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M20.231 6.806a3.267 3.267 0 0 1-3.266-3.266c.004-.354.066-.706.184-1.04a3.269 3.269 0 0 0-2.139 2.342 3.274 3.274 0 0 0 .037 1.639 3.266 3.266 0 0 0 3.882 2.28 3.252 3.252 0 0 0 1.448-.766 3.24 3.24 0 0 0 .894-1.374 3.208 3.208 0 0 1-1.04.185Zm-6.22 8.694H8.5v-4h4.074m-5.736 8a2 2 0 0 0 4 0M5.5 8.5l-3-2 3-2 3 2-3 2m-3.5 3h4.5v4H2m0-7h6.338c1.97 0 3.627 1.274 4.236 3.038l2.104 5.801c.099.2.16.423.16.661a1.5 1.5 0 0 1-1.5 1.5H2m20 2H2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainNight);
export default __webpack_public_path__ + "static/media/train-night.a7106e3a4b08c5dae4ce01f8b94dbd6c.svg";
export { ForwardRef as ReactComponent };